module.exports = __webpack_public_path__ + "img/8.36174f11.png";